import { render, staticRenderFns } from "./DashIntakeStats.vue?vue&type=template&id=79c44534&scoped=true&"
import script from "./DashIntakeStats.vue?vue&type=script&lang=js&"
export * from "./DashIntakeStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c44534",
  null
  
)

export default component.exports